import { AccessRoles, BillingTabs, GroupManagementTabs } from 'constants/enums';
import { getPath } from 'routes';

/**
 * Where a session starts. A billing admin's first stop is Billing & Credits (Alex, round 3, item 3;
 * restated by Michel, 2026-09-11): they land on the balance, which is where the payment-method
 * prompt and the credit reload are. SYSOP is excluded — support staff hold BILLING nowhere in
 * particular and belong in Admin.
 *
 * Shared because the rule has three entry points — password login, TFA, and the end of the signup
 * wizard — and it was previously written into only one of them, so a billing admin arriving by
 * either of the other two landed somewhere else.
 */
export const postLoginRoute = (roles: Array<string | number>, primaryRole?: string | number) => {
  const parsed = (roles || []).map((role) => Number(role));
  const isSysop = parsed.includes(AccessRoles.SYSOP);

  if (!isSysop && parsed.includes(AccessRoles.BILLING)) {
    return getPath().dashboard.billing(BillingTabs.OVERVIEW);
  }
  const primary = primaryRole === undefined ? undefined : Number(primaryRole);
  if (primary === AccessRoles.GROUP_MANAGEMENT || primary === AccessRoles.SYSOP) {
    return getPath().dashboard.groupManagement.layout(GroupManagementTabs.CONFIGURATION);
  }
  return getPath().dashboard.layout;
};
